import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Hooks
import { handleLaunchExternalLink } from 'Shared/utils/external-link';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';

// Components
import BaseCta, { BaseCtaShowProps } from './BaseCta';
import { Illustrations } from 'Wpds/components/illustration';

// Styles
import './BaDoesNotExist.scss';

interface Props extends BaseCtaShowProps {
  user: User;
}

const BaDoesNotExist = ({ user, ...rest }: Props) => {
  const { getBaUrl, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: true });
  const { trackTakeAssessmentButtonClick } = useBaTracking();

  const handleButtonClick = async () => {
    trackTakeAssessmentButtonClick();
    const url = await getBaUrl();
    handleLaunchExternalLink({ href: url });
  };

  return (
    <BaseCta
      title="Take the PI Behavioral Assessment"
      description="Make meetings even more productive. Learn your biggest behavioral strengths and caution areas, and discover how to work best with your co-workers. (It takes just 6 minutes.)"
      illustration={Illustrations.take_ba}
      buttonText=" Take the assessment"
      onButtonClick={handleButtonClick}
      footerText="Learn More"
      footerLink={ExternalLinksConstants.learn_more_about_taking_ba}
      loading={isCreatingBaLink}
      buttonSize="lg"
      buttonNote="This will open in a new tab. Please return here when you’re done."
      {...rest}
    />
  );
};

export default BaDoesNotExist;
